import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getAllActiveProducts,
  getAllExpiredProducts,
  getPrimaryContactWithUID,
} from "../../Api/ApiCalls";
import LoadingSpinner from "../../common/Loading";
import { PopupPrimaryContact } from "./PopupPrimaryContact";

export const ActiveAndExpiredProducts = () => {
  const location = useLocation();

  const path = location.pathname;
  const [loading, setLoading] = useState(true);
  const [popLoading, setPopLoading] = useState(true);
  const [Products, setProducts] = useState([]);
  const [popup, setPopup] = useState({
    show: false,
    data: null,
  });

  const getActiveProducts = async () => {
    setLoading(true);
    try {
      const result = await getAllActiveProducts();
      if (result.status) {
        setProducts(result.data);
      }

      setLoading(false);
    } catch (err) {
      console.log("Error while fetching all active products", err);
      setLoading(false);
    }
  };
  const getExpiredProducts = async () => {
    setLoading(true);
    try {
      const result = await getAllExpiredProducts();
      if (result.status) {
        setProducts(result.data);
      }
      setLoading(false);
    } catch (err) {
      console.log("Error while fetching all expired products", err);
      setLoading(false);
    }
  };

  const getPrimaryContact = async (uid) => {
    setPopLoading(true);
    setPopup({ show: true, data: null });
    try {
      const result = await getPrimaryContactWithUID(uid);
      if (result.status) {
        setPopup({ show: true, data: result.data[0] });
      }

      setPopLoading(false);
    } catch (err) {
      console.log("Error while fetching primary contact", err);
      setPopLoading(false);
    }
  };

  useEffect(() => {
    if (path.includes("active")) getActiveProducts();
    if (path.includes("expired")) getExpiredProducts();
  }, []);

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-10">
            <h2 className="text-4xl text-[#96BF61] font-bold mb-6">
              {(path.includes("active") && "Active Products") ||
                (path.includes("expired") && "Expired Products")}
            </h2>
            {loading && <LoadingSpinner />}
            {!loading && (
              <>
                <div className="grid grid-cols-12 mt-3">
                  <div className="col-span-12 lg:col-span-12">
                    <div className="rounded-[21px] rounded-bl-none rounded-br-none">
                      <div className=" overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none">
                        <table className="min-w-full border manage-active-expired-product">
                          <thead className="border bg-white">
                            <tr>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Corporation Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Organization Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Store Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Location
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                SKU
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Product Expiry
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                QTY
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Status
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Primary Contact
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Products.length !== 0 &&
                              Products.map((product, index) => {
                                return (
                                  <tr
                                    key={index}
                                    className="bg-white border transition duration-300 ease-in-out hover:bg-gray-100"
                                  >
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {product?.corporation_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {product?.organization_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {product?.store_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {product?.location}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {product?.sku}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {product?.expiry_date}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {product?.quantity}
                                    </td>
                                    <td
                                      className={`text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 ${
                                        product?.status == "active"
                                          ? "text-green-600"
                                          : "text-red-600"
                                      }`}
                                    >
                                      {product?.status.charAt(0).toUpperCase() +
                                        product?.status.slice(1)}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      <div
                                        onClick={() => {
                                          getPrimaryContact(product.user_uid);
                                        }}
                                        className="flex items-center justify-center cursor-pointer"
                                      >
                                        <svg
                                          fill="#000000"
                                          height="24"
                                          width="24"
                                          version="1.1"
                                          id="Capa_1"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 32.055 32.055"
                                        >
                                          <g>
                                            <path
                                              d="M3.968,12.061C1.775,12.061,0,13.835,0,16.027c0,2.192,1.773,3.967,3.968,3.967c2.189,0,3.966-1.772,3.966-3.967
		C7.934,13.835,6.157,12.061,3.968,12.061z M16.233,12.061c-2.188,0-3.968,1.773-3.968,3.965c0,2.192,1.778,3.967,3.968,3.967
		s3.97-1.772,3.97-3.967C20.201,13.835,18.423,12.061,16.233,12.061z M28.09,12.061c-2.192,0-3.969,1.774-3.969,3.967
		c0,2.19,1.774,3.965,3.969,3.965c2.188,0,3.965-1.772,3.965-3.965S30.278,12.061,28.09,12.061z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/*  */}
            {!loading && Products.length === 0 && (
              <h2 className="text-2xl font-medium mr-auto text-gray-500 text-center mt-[10%]">
                No Data Found!
              </h2>
            )}
          </div>
        </div>
        <div>
          {
            <PopupPrimaryContact
              setPopup={setPopup}
              popup={popup}
              loading={popLoading}
            />
          }
        </div>
      </div>
    </>
  );
};
